import { finalize } from 'rxjs/operators';
import { UserService } from 'src/app/services/user.service';
import { ProductModel } from 'src/app/models/wardrobe.model';
import { GeneralService } from 'src/app/services/general.service';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { WardrobeService } from 'src/app/services/wardrobe.service';
import { IonInfiniteScroll, ModalController } from '@ionic/angular';
import { PaginatedResponse } from 'src/app/models/paginated-response.model';

@Component({
  selector: 'shc-swap-item-modal',
  templateUrl: './swap-item-modal.component.html',
  styleUrls: ['./swap-item-modal.component.scss'],
})
export class SwapItemModalComponent implements OnInit {
  page: number;
  userId: number;
  loading = false;
  @Input() senderId: number;
  @Input() actualProductId: any;
  products: PaginatedResponse<ProductModel>;
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;

  constructor(
    private wardrobeService: WardrobeService,
    private generalService: GeneralService,
    private modalCtrl: ModalController,
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.get().subscribe(res => {
      this.userId = res.id;
      this.getProducts('');
    });
  }

  closeModal() {
    this.modalCtrl.dismiss(null, '', 'swapItem');
  }

  getProducts(event) {
    this.loading = true;
    this.generalService.showLoader();
    this.wardrobeService.productsList({ page: this.page, user_id: this.userId }).pipe(
      finalize(() => this.generalService.hideLoader())
    ).subscribe(res => {
      if (this.products && this.products.meta) {
        if (this.page === 1) {
          this.products = res;
        } else {
          this.products.meta = res.meta;
          this.products.data = [...this.products.data, ...res.data];
        }
      } else {
        this.products = res;
      }
      if (event) {
        event.target.complete();
      }
      this.page++;
      this.loading = false;
    }, err => {
      this.loading = false;
    });
  }

  loadData(event): void {
    if (this.products.meta.current_page < this.products.meta.last_page) {
      this.getProducts(event);
    } else {
      this.infiniteScroll.disabled = true;
    }
  }
}
